import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelSettingsGroupsEditResolverErrorStatesEnum {
    GetClientFailed = ErrorStateScheduleEnum.PanelSettingsGroupsEditResolverStatesStartIndex,
    ClientNotFound,
    GetIndividualFailed,
    IndividualNotFound,
    GetCompanyFailed,
    CompanyNotFound,
    GetTradingGroupStatusTriggersFailed
}
